import { all, takeLatest, put } from 'redux-saga/effects';

import {
  types,
  setConnectedSuccess,
  setDisconnectedSuccess,
} from '@coconut/services/redux/internet';
import { showAlertBanner } from '@coconut/services/redux/alertBanner';
import {
  ALERT_SUCCESS_THEME,
  ALERT_OFFLINE_THEME,
} from '@coconut/constants/alertBannerThemes';

function* setConnectedFlow() {
  yield put(
    showAlertBanner({
      message: 'qaOnWeb.internet.connected',
      theme: ALERT_SUCCESS_THEME,
    })
  );

  yield put(setConnectedSuccess());
}

function* setDisconnectedFlow() {
  yield put(
    showAlertBanner({
      message: 'qaOnWeb.internet.disconnected',
      theme: ALERT_OFFLINE_THEME,
    })
  );

  yield put(setDisconnectedSuccess());
}

export default function* () {
  yield all([
    takeLatest(types.SET_CONNECTED, setConnectedFlow),
    takeLatest(types.SET_DISCONNECTED, setDisconnectedFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/internet.js